import { render, staticRenderFns } from "./3DItem.vue?vue&type=template&id=263135ca"
import script from "./3DItem.vue?vue&type=script&lang=js"
export * from "./3DItem.vue?vue&type=script&lang=js"
import style0 from "./3DItem.vue?vue&type=style&index=0&id=263135ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports